/* Welnor — interactive behaviors */
(function () {
  'use strict';

  // ===== VIDEO REEL CAROUSEL =====
  function initReel(reel) {
    var track = reel.querySelector('[data-reel-track]');
    var prev = reel.querySelector('[data-reel-prev]');
    var next = reel.querySelector('[data-reel-next]');
    if (!track) return;
    var step = 200;
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left:  step, behavior: 'smooth' }); });
  }

  // ===== GALLERY SWIPE + THUMB SYNC =====
  function initGallery(gallery) {
    var track = gallery.querySelector('[data-gallery-track]');
    if (!track) return;

    // Find sibling .thumbs
    var thumbsEl = gallery.parentElement.querySelector('[data-thumbs]');
    var thumbs = thumbsEl ? thumbsEl.querySelectorAll('.thumb') : [];

    function setActiveByIndex(index) {
      thumbs.forEach(function (t, i) {
        var matches = i === index;
        t.classList.toggle('is-active', matches);
        t.setAttribute('aria-selected', matches ? 'true' : 'false');
      });
    }

    // Thumb click → scroll gallery to slide
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var idx = parseInt(thumb.getAttribute('data-thumb-index') || '0', 10);
        var slide = track.querySelector('[data-slide-index="' + idx + '"]');
        if (slide) {
          track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        }
        setActiveByIndex(idx);
      });
    });

    // Scroll position → update active thumb (debounced)
    var scrollTimer;
    track.addEventListener('scroll', function () {
      if (scrollTimer) cancelAnimationFrame(scrollTimer);
      scrollTimer = requestAnimationFrame(function () {
        var slideWidth = track.offsetWidth;
        if (slideWidth === 0) return;
        var index = Math.round(track.scrollLeft / slideWidth);
        setActiveByIndex(index);
      });
    }, { passive: true });
  }

  // ===== BEFORE/AFTER CAROUSEL =====
  function initBA(wrap) {
    var trackD = wrap.querySelector('[data-ba-track-d]');
    var prev = wrap.querySelector('[data-ba-prev]');
    var next = wrap.querySelector('[data-ba-next]');
    var dots = wrap.parentElement ? wrap.parentElement.querySelectorAll('[data-ba-dot]') : [];
    if (!trackD) return;

    var tiles = trackD.children;
    var current = 0;
    var perPage = 3;

    function setActive(idx) {
      current = Math.max(0, Math.min(tiles.length - 1, idx));
      // Smooth scroll the tile into view
      var tile = tiles[current];
      if (tile) tile.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === current);
      });
    }

    if (prev) prev.addEventListener('click', function () { setActive(current - 1); });
    if (next) next.addEventListener('click', function () { setActive(current + 1); });
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { setActive(i); });
    });
  }

  // Mobile BA — sync dots with scroll position
  function initBAMobile(track) {
    var section = track.closest('section');
    var dots = section ? section.querySelectorAll('[data-ba-dot-m]') : [];
    var tiles = track.children;
    if (!tiles.length || !dots.length) return;

    var scrollTimer;
    track.addEventListener('scroll', function () {
      if (scrollTimer) cancelAnimationFrame(scrollTimer);
      scrollTimer = requestAnimationFrame(function () {
        var trackRect = track.getBoundingClientRect();
        var trackCenter = trackRect.left + trackRect.width / 2;
        var closestIndex = 0;
        var closestDist = Infinity;
        for (var i = 0; i < tiles.length; i++) {
          var tileRect = tiles[i].getBoundingClientRect();
          var tileCenter = tileRect.left + tileRect.width / 2;
          var dist = Math.abs(tileCenter - trackCenter);
          if (dist < closestDist) { closestDist = dist; closestIndex = i; }
        }
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === closestIndex); });
      });
    }, { passive: true });
  }

  function init() {
    document.querySelectorAll('[data-reel]').forEach(initReel);
    document.querySelectorAll('[data-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-ba]').forEach(initBA);
    document.querySelectorAll('[data-ba-track-m]').forEach(initBAMobile);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
